// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y5Edq","field":"styles_field__1DHxc","fieldCol":"styles_fieldCol__24p8o","diffCol":"styles_diffCol__IwQy5","diff":"styles_diff__38uT7"};